import React from 'react';
import EditGame from '../../components/games/edit-game';

const EditGameContainer = () => {
    return <EditGame />;
};

export default EditGameContainer;
